import React, { Component } from 'react';
import LogoWhite from './logo_white.png';
import LogoBlack from './logo_black.png';

import './Logo.css';

export const LogoSize = {
  default: {
    heightWidth: "30px",
    fontSize: "16pt",
    hideTextClass: "hidden-xs",
  },
  medium: {
    heightWidth: "50px",
    fontSize: "20pt",
    hideTextClass: "hidden-xs hidden-sm",
  },
  large: {
    heightWidth: "55px",
    fontSize: "30pt",
  },
};

class Logo extends Component {
  render() {
    const {
      dark = false,
      size = LogoSize.default,
      autoHide = true,
      onClick,
    } = this.props;

    const imgSrc = dark ? LogoBlack : LogoWhite;

    const textStyle = {
      color: dark ? "black" : "white",
      fontSize: size.fontSize,
    };

    const imgStyle = {
      height: size.heightWidth,
      width: size.heightWidth,
    };

    return (
      <div className="Logo-container" onClick={onClick}>
        <img className="Logo-icon" style={imgStyle} src={imgSrc} alt="Passcode.io logo" />
        <span className={`Logo-text ${autoHide ? size.hideTextClass : ""}`} style={textStyle}>Passcode.io</span>
      </div>
    );
  }
}

export default Logo;


// WEBPACK FOOTER //
// ./src/brand/Logo.js